module.exports = __webpack_public_path__ + "img/1.2f13371e.png";